import React from "react";

interface PersonFilledProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
}

export function PersonFilled(props: PersonFilledProps) {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="7.5" cy="4" r="3" />
      <path d="M2.5 13.5v-1.5c0-2.5 2.5-4 5-4s5 1.5 5 4v1.5H2.5z" />
    </svg>
  );
}
